import { Component, Input } from '@angular/core';
import { hebrewDays } from '../../../../shared/constants/hebrew-days';

@Component({
  selector: 'app-my-day',
  templateUrl: './my-day.component.html',
  styleUrls: ['./my-day.component.scss']
})
export class MyDayComponent {
  @Input({ required: true }) widgetData!: any;
  @Input() selectedDay: Date = new Date();
  currentDay: string = hebrewDays[new Date().getDay()];
}
